import React, { useEffect } from "react"
import { Redirect } from "react-router"
import Loader from "../../../components/Loader"
import { useLeaveImpersonationManage } from "../../hooks"

interface Props {
  redirectPath: string
}

const LeaveImpersonationRouteContainer: React.FC<Props> = ({
  redirectPath
}) => {
  const { impersonationEnable, leaveImpersonationHandler } =
    useLeaveImpersonationManage()

  useEffect(() => {
    if (!impersonationEnable) {
      return
    }

    leaveImpersonationHandler()
  }, [impersonationEnable])

  if (!impersonationEnable) {
    return <Redirect to={redirectPath || "/"} />
  }
  return <Loader />
}

export default LeaveImpersonationRouteContainer
